(function () {
  if (window.__cartCrossSellRegistered) return;
  window.__cartCrossSellRegistered = true;

  function addTwoProteins(card) {
    if (card.classList.contains('is-loading')) return;

    var chocId = parseInt(card.dataset.chocId || '0', 10);
    var sandiaId = parseInt(card.dataset.sandiaId || '0', 10);
    var chocOk = card.dataset.chocOk === 'true';
    var sandiaOk = card.dataset.sandiaOk === 'true';

    var items = [];
    if (chocOk && sandiaOk) {
      items = [{ id: chocId, quantity: 1 }, { id: sandiaId, quantity: 1 }];
    } else if (chocOk) {
      items = [{ id: chocId, quantity: 2 }];
    } else if (sandiaOk) {
      items = [{ id: sandiaId, quantity: 2 }];
    } else {
      return;
    }

    card.classList.add('is-loading');
    var routes = (window.Theme && window.Theme.routes) || {};

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch((routes.cart_url || '/cart') + '.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        card.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: cart.item_count } }
        }));
      })
      .catch(function (err) {
        console.error('[cart-cross-sell] error añadiendo al carrito', err);
        card.classList.remove('is-loading');
      });
  }

  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._bind();
      this._observer = new MutationObserver(function () { self._bind(); });
      this._observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._observer) { this._observer.disconnect(); this._observer = null; }
    }

    _bind() {
      var cards = this.querySelectorAll('.cart-cross-sell__card');
      Array.prototype.forEach.call(cards, function (card) {
        if (card.dataset.ccsBound === 'true') return;
        card.dataset.ccsBound = 'true';
        card.addEventListener('click', function (e) {
          e.preventDefault();
          addTwoProteins(card);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            addTwoProteins(card);
          }
        });
      });
    }
  }

  if (!customElements.get('cart-cross-sell')) {
    customElements.define('cart-cross-sell', CartCrossSell);
  }
})();